import {useEffect, useState} from "react";
import {GET_ALL_FOCOLAI_BY_SOGGETTO_URL, GET_ALL_FOCOLAI_URL} from "../../../../services/utils/ApiUrls";
import axios from "axios";
import {getConfig} from "../../../../services/utils/ConfigUtils";
import {decriptMessage} from "../../../../utils/SecureData";
import {isEmpty} from "../../../../utils/GenericUtils";

export default function useGetAllFocolai(stato, pageNumber, value, sort, dir) {
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);
	const [focolai, setFocolai] = useState([]);
	const [hasMore, setHasMore] = useState(false);
	
	function getData(stato) {
		if (stato === "In gestione") {
			return {
				active: true,
			}
		}
		return {
			stato: stato,
			active: false,
		}
	}
	
	function getUrl(value, pageNumber, sort, dir) {
		if (isEmpty(value)) {
			return GET_ALL_FOCOLAI_URL + pageNumber + "/" + sort + "/" + dir
		} else {
			return GET_ALL_FOCOLAI_BY_SOGGETTO_URL;
		}
	}
	
	useEffect(() => {
		setFocolai([])
	}, [stato, value, sort, dir])
	
	useEffect(() => {
		if (isEmpty(value)) {
			setLoading(true);
			setError(false);
			axios({
				method: "POST",
				url: getUrl(value, pageNumber, sort, dir),
				data: getData(stato, value),
				...getConfig(),
			}).then(response => {
				setFocolai(prevState => {
					let newState = [...prevState, ...response.data];
					return newState.filter((object, index) => index === newState.findIndex(obj => JSON.stringify(obj) === JSON.stringify(object)))
				})
				setHasMore(response.data.length > 0);
				setLoading(false);
			}).catch(() => {
				setError(true);
				setLoading(false);
			})
		} else {
			setLoading(true);
			setError(false);
			axios({
				method: "POST",
				url: getUrl(value, pageNumber, sort, dir),
				data: value,
				headers: {
					Authorization: "Bearer " + decriptMessage(sessionStorage.getItem("key_asl_to")),
				}
			}).then(response => {
				setFocolai(prevState => {
					let newState = [...prevState, ...response.data];
					return newState.filter((object, index) => index === newState.findIndex(obj => JSON.stringify(obj) === JSON.stringify(object)))
				})
				setHasMore(false);
				setLoading(false);
			}).catch(() => {
				setError(true);
				setLoading(false);
			})
		}
	}, [stato, pageNumber, value, sort, dir])
	
	
	return {loading, error, focolai, hasMore}
}
